import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { PROJECTS } from "@/data/projects";
import Overline from "./Overline";
import { reveal, revealStaggered, VIEW_40, VIEW_80 } from "./motion";

const SHOWN = PROJECTS.slice(0, 4);

export const AboutSelectedWork = () => (
  <section data-testid="about-work" className="px-6 py-28 md:px-16 lg:px-24">
    <motion.div
      variants={reveal}
      initial="hidden"
      whileInView="show"
      viewport={VIEW_80}
      className="flex flex-wrap items-end justify-between gap-8"
    >
      <div>
        <Overline>Selected Work</Overline>
        <h2 className="font-display max-w-2xl text-3xl font-bold leading-tight text-[#F4F6FB] md:text-5xl">
          Artifacts from the void.
        </h2>
      </div>
      <a
        href="/work"
        data-testid="about-all-work-link"
        className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#06B6D4] transition-colors duration-300 hover:text-[#F4F6FB]"
      >
        Full showcase →
      </a>
    </motion.div>
    <div className="mt-16">
      {SHOWN.map((p, i) => (
        <motion.div
          key={p.slug}
          variants={revealStaggered}
          initial="hidden"
          whileInView="show"
          viewport={VIEW_40}
          custom={i * 0.08}
        >
          <Link
            to={`/work/${p.slug}`}
            data-testid={`about-work-${p.slug}`}
            className="group grid items-baseline gap-2 border-t border-white/10 py-8 transition-colors duration-500 last:border-b hover:border-[#8B5CF6]/40 md:grid-cols-[1fr_2fr_auto] md:gap-8"
          >
            <h3 className="font-display text-xl font-semibold text-[#F4F6FB] transition-colors duration-300 group-hover:text-[#8B5CF6] md:text-2xl">
              {p.title}
            </h3>
            <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#F4F6FB]/45">
              {p.tag} — {p.year}
            </p>
            <ArrowUpRight className="h-5 w-5 text-[#8B5CF6] transition-transform duration-300 group-hover:-translate-y-1 group-hover:translate-x-1" />
          </Link>
        </motion.div>
      ))}
    </div>
  </section>
);

export default AboutSelectedWork;
